<template>
    <div class="why-buy-banner" :class="{ 'banner--list': bannerType === 'whyBuyList'}" role="complementary">
        <div class="why-buy-banner__inner">
            <div role="button" tabindex="0" @click="open" @keydown.enter.prevent="open" @keydown.space.prevent="open">
                <p class="open-modal">
                    <span  class="why-buy-video" v-if="bannerType === 'whyBuyVideo'">
                        Get More at Sweetwater
                        <span class="watch-now-btn">
                            <span>Watch Now</span>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.051 30.051"><path d="M19.982 14.438l-6.24-4.536a.752.752 0 0 0-1.195.607v9.069a.75.75 0 0 0 1.195.606l6.24-4.532a.747.747 0 0 0 0-1.214z"/><path d="M15.026.002C6.726.002 0 6.728 0 15.028c0 8.297 6.726 15.021 15.026 15.021 8.298 0 15.025-6.725 15.025-15.021.001-8.3-6.727-15.026-15.025-15.026zm0 27.54c-6.912 0-12.516-5.601-12.516-12.514 0-6.91 5.604-12.518 12.516-12.518 6.911 0 12.514 5.607 12.514 12.518.001 6.913-5.603 12.514-12.514 12.514z"/></svg>
                        </span>
                    </span>

                    <span class="why-buy-list" v-else-if="bannerType === 'whyBuyList'">
                        10 Reasons to Shop at Sweetwater <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129" width="512" height="512"><g fill="#fff"><path d="M64.5 122.6c32 0 58.1-26 58.1-58.1S96.5 6.4 64.5 6.4 6.4 32.5 6.4 64.5s26.1 58.1 58.1 58.1zm0-108c27.5 0 49.9 22.4 49.9 49.9S92 114.4 64.5 114.4 14.6 92 14.6 64.5 37 14.6 64.5 14.6z"/><path d="M51.1 93.5c.8.8 1.8 1.2 2.9 1.2 1 0 2.1-.4 2.9-1.2l26.4-26.4c.8-.8 1.2-1.8 1.2-2.9 0-1.1-.4-2.1-1.2-2.9L56.9 34.9c-1.6-1.6-4.2-1.6-5.8 0-1.6 1.6-1.6 4.2 0 5.8l23.5 23.5-23.5 23.5c-1.6 1.6-1.6 4.2 0 5.8z"/></g></svg>
                    </span>
                </p>
            </div>

            <newModal :visible="visible" :on-close="close" :on-close-complete="closeComplete" :oldModalStyles="true" class="modal__why-buy">
                <div v-if="bannerType === 'whyBuyVideo'">
                    <div class="border"></div>
                    <h2>Get More at Sweetwater</h2>
                    <div class="why-buy-video">
                        <iframe width="560" height="315" :src="youtubeSrc" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen title="Get More at Sweetwater"></iframe>
                    </div>

                    <div class="why-buy-video-text">
                        Sweetwater... One part music gear wonderland. One part stunning customer service. One part passion. Since 1979, Sweetwater has been committed to giving music makers the ultimate shopping experience. Whether it's our helpful advice &mdash; personalized to you, a free 2-year warranty on nearly everything we sell, our knack for fast, free shipping, our almost "obsessive" attention to detail, the free Product Support or the sweet way we say "thanks." These are just a few of the many reasons why more musicians get their gear at Sweetwater than anywhere else. So whether you’re buying your first guitar or building your dream studio, get your gear from a place you can trust, from people that care. <strong>Get more at Sweetwater.</strong>

                        <div class="why-buy-btn"><a @click.prevent="close" href="#" class="btn">Close Window</a></div>
                    </div>
                </div>
                <div v-else-if="bannerType === 'whyBuyList'">
                    <div class="border"></div>
                    <h2>10 Reasons to Shop at Sweetwater</h2>
                    <div class="why-buy-grid">
                        <div class="why-buy-grid__item">
                            <img :srcset="getImage('freeShipping', 'srcset')" :src="getImage('freeShipping')" alt="" aria-hidden="true">
                            <div class="why-buy-grid__item__text">
                                <div class="why-buy-grid__item__num"></div>
                                <div class="why-buy-grid__item__description" v-if="showFreeShippingMsg">
                                    <a href="/about/free-shipping/" v-on:itemClicked="itemClicked">Free shipping</a> and one of the fastest
                                    turnaround times in the industry.
                                </div>
                                <div class="why-buy-grid__item__description" v-else>
                                    <a href="/about/free-shipping/" v-on:itemClicked="itemClicked">Fast shipping</a> with same-day turnaround on most <span class="nowrap">in-stock orders.</span>
                                </div>
                            </div>
                        </div>

                        <div class="why-buy-grid__item">
                            <img :srcset="getImage('warranty', 'srcset')" :src="getImage('warranty')" alt="" aria-hidden="true">
                            <div class="why-buy-grid__item__text">
                                <div class="why-buy-grid__item__num"></div>
                                <div class="why-buy-grid__item__description">
                                    The peace of mind of a <a href="/about/warranty/" v-on:itemClicked="itemClicked">free 2-year warranty</a>.
                                    If something goes wrong, we’ll take care of it.
                                </div>
                            </div>
                        </div>
                        <div class="why-buy-grid__item">
                            <img :srcset="getImage('experts', 'srcset')" :src="getImage('experts')" alt="" aria-hidden="true">
                            <div class="why-buy-grid__item__text">
                                <div class="why-buy-grid__item__num"></div>
                                <div class="why-buy-grid__item__description">
                                    If you need advice, <a href="/about/sales-engineers/" v-on:itemClicked="itemClicked">our trained
                                    &amp; seasoned experts</a> can help with any need from studio to stage.
                                </div>
                            </div>
                        </div>

                        <div class="why-buy-grid__item">
                            <img :srcset="getImage('techSupport', 'srcset')" :src="getImage('techSupport')" alt="" aria-hidden="true">
                            <div class="why-buy-grid__item__text">
                                <div class="why-buy-grid__item__num"></div>
                                <div class="why-buy-grid__item__description">
                                    Our <a href="/about/support/" v-on:itemClicked="itemClicked">Product Support</a> team has seen it
                                    all and is here to help, free of charge!
                                </div>
                            </div>
                        </div>

                        <div class="why-buy-grid__item">
                            <img :srcset="getImage('guitarInspection', 'srcset')" :src="getImage('guitarInspection')" alt="" aria-hidden="true">
                            <div class="why-buy-grid__item__text">
                                <div class="why-buy-grid__item__num"></div>
                                <div class="why-buy-grid__item__description">
                                    <a href="/about/guitars/" v-on:itemClicked="itemClicked">55-point guitar inspection</a> ensures your
                                    instrument plays perfect, right out of the box.
                                </div>
                            </div>
                        </div>

                        <div class="why-buy-grid__item">
                            <img :srcset="getImage('financing', 'srcset')" :src="getImage('financing')" alt="" aria-hidden="true">
                            <div class="why-buy-grid__item__text">
                                <div class="why-buy-grid__item__num"></div>
                                <div class="why-buy-grid__item__description">
                                    <a href="/financing/" v-on:itemClicked="itemClicked">Special financing</a> and <a href="/payments/easy/" v-on:itemClicked="itemClicked">easy payment plans</a>
                                    make it simple to get the gear you need.
                                </div>
                            </div>
                        </div>

                        <div class="why-buy-grid__item">
                            <img :srcset="getImage('salesEngineers', 'srcset')" :src="getImage('salesEngineers')" alt="" aria-hidden="true">
                            <div class="why-buy-grid__item__text">
                                <div class="why-buy-grid__item__num"></div>
                                <div class="why-buy-grid__item__description">
                                    <a href="/about/sales-engineers/" v-on:itemClicked="itemClicked">Our sales team</a> is made up of musicians who
                                    understand your unique needs and goals.
                                </div>
                            </div>
                        </div>

                        <div class="why-buy-grid__item">
                            <img :srcset="getImage('inSync', 'srcset')" :src="getImage('inSync')" alt="" aria-hidden="true">
                            <div class="why-buy-grid__item__text">
                                <div class="why-buy-grid__item__num"></div>
                                <div class="why-buy-grid__item__description">
                                    <a href="/insync/" v-on:itemClicked="itemClicked">inSync</a> is the premier place to find research,
                                    tips & tricks, and reviews for what matters
                                    most to musicians.
                                </div>
                            </div>
                        </div>

                        <div class="why-buy-grid__item">
                            <img :srcset="getImage('warehouse', 'srcset')" :src="getImage('warehouse')" alt="" aria-hidden="true">
                            <div class="why-buy-grid__item__text">
                                <div class="why-buy-grid__item__num"></div>
                                <div class="why-buy-grid__item__description">
                                    <strong>Tens of thousands of products</strong> under one
                                    roof ensures we have the gear you need.
                                </div>
                            </div>
                        </div>

                        <div class="why-buy-grid__item">
                            <img :srcset="getImage('dealzone', 'srcset')" :src="getImage('dealzone')" alt="" aria-hidden="true">
                            <div class="why-buy-grid__item__text">
                                <div class="why-buy-grid__item__num"></div>
                                <div class="why-buy-grid__item__description">
                                    From our <a href="/dealzone" v-on:itemClicked="itemClicked">money-saving deals</a> to the bag of
                                    candy that ships with every order, you’ll
                                    always get more than you paid for.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="border"></div>
                    <h2><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 578.106 578.106"><path d="M577.83 456.128c1.225 9.385-1.635 17.545-8.568 24.48l-81.396 80.781c-3.672 4.08-8.465 7.551-14.381 10.404-5.916 2.857-11.729 4.693-17.439 5.508-.408 0-1.635.105-3.676.309-2.037.203-4.689.307-7.953.307-7.754 0-20.301-1.326-37.641-3.979s-38.555-9.182-63.645-19.584c-25.096-10.404-53.553-26.012-85.376-46.818-31.823-20.805-65.688-49.367-101.592-85.68-28.56-28.152-52.224-55.08-70.992-80.783-18.768-25.705-33.864-49.471-45.288-71.299-11.425-21.828-19.993-41.616-25.705-59.364S4.59 177.362 2.55 164.51-.306 141.56.102 134.216c.408-7.344.612-11.424.612-12.24.816-5.712 2.652-11.526 5.508-17.442s6.324-10.71 10.404-14.382L98.022 8.756c5.712-5.712 12.24-8.568 19.584-8.568 5.304 0 9.996 1.53 14.076 4.59s7.548 6.834 10.404 11.322l65.484 124.236c3.672 6.528 4.692 13.668 3.06 21.42-1.632 7.752-5.1 14.28-10.404 19.584l-29.988 29.988c-.816.816-1.53 2.142-2.142 3.978s-.918 3.366-.918 4.59c1.632 8.568 5.304 18.36 11.016 29.376 4.896 9.792 12.444 21.726 22.644 35.802s24.684 30.293 43.452 48.653c18.36 18.77 34.68 33.354 48.96 43.76 14.277 10.4 26.215 18.053 35.803 22.949 9.588 4.896 16.932 7.854 22.031 8.871l7.648 1.531c.816 0 2.145-.307 3.979-.918 1.836-.613 3.162-1.326 3.979-2.143l34.883-35.496c7.348-6.527 15.912-9.791 25.705-9.791 6.938 0 12.443 1.223 16.523 3.672h.611l118.115 69.768c8.571 5.308 13.67 12.038 15.303 20.198z" fill="#222222"/></svg>
                    Call us at <phone number="8002224700" v-on:itemClicked="itemClicked"></phone></h2>
                </div>
            </newModal>
        </div>
    </div>
</template>

<script>
import newModal from 'components/new-modal.vue';

export default {
    components: {
        newModal
    },
    name: 'whyBuyBanner',
    data() {
        return {
            visible: false,
            canShowImages: false,
            youtubeSrc: '',
            images: {
                freeShipping: {
                    src: 'https://media.sweetwater.com/m/header/welcome/photos/why-buy-1.jpg',
                    srcset: 'https://media.sweetwater.com/m/header/welcome/photos/why-buy-1.jpg, https://media.sweetwater.com/m/header/welcome/photos/why-buy-1@2x.jpg 2x',
                },
                warranty: {
                    src: 'https://media.sweetwater.com/m/header/welcome/photos/why-buy-2.jpg',
                    srcset: 'https://media.sweetwater.com/m/header/welcome/photos/why-buy-2.jpg, https://media.sweetwater.com/m/header/welcome/photos/why-buy-2@2x.jpg 2x',
                },
                experts: {
                    src: 'https://media.sweetwater.com/m/header/welcome/photos/why-buy-3.jpg',
                    srcset: 'https://media.sweetwater.com/m/header/welcome/photos/why-buy-3.jpg, https://media.sweetwater.com/m/header/welcome/photos/why-buy-3@2x.jpg 2x',
                },
                techSupport: {
                    src: 'https://media.sweetwater.com/m/header/welcome/photos/why-buy-4.jpg',
                    srcset: 'https://media.sweetwater.com/m/header/welcome/photos/why-buy-4.jpg, https://media.sweetwater.com/m/header/welcome/photos/why-buy-4@2x.jpg 2x',
                },
                guitarInspection: {
                    src: 'https://media.sweetwater.com/m/header/welcome/photos/why-buy-5.jpg',
                    srcset: 'https://media.sweetwater.com/m/header/welcome/photos/why-buy-5.jpg, https://media.sweetwater.com/m/header/welcome/photos/why-buy-5@2x.jpg 2x',
                },
                financing: {
                    src: 'https://media.sweetwater.com/m/header/welcome/photos/why-buy-6.jpg',
                    srcset: 'https://media.sweetwater.com/m/header/welcome/photos/why-buy-6.jpg, https://media.sweetwater.com/m/header/welcome/photos/why-buy-6@2x.jpg 2x',
                },
                salesEngineers: {
                    src: 'https://media.sweetwater.com/m/header/welcome/photos/why-buy-7.jpg',
                    srcset: 'https://media.sweetwater.com/m/header/welcome/photos/why-buy-7.jpg, https://media.sweetwater.com/m/header/welcome/photos/why-buy-7@2x.jpg 2x',
                },
                inSync: {
                    src: 'https://media.sweetwater.com/m/header/welcome/photos/why-buy-8.jpg',
                    srcset: 'https://media.sweetwater.com/m/header/welcome/photos/why-buy-8.jpg, https://media.sweetwater.com/m/header/welcome/photos/why-buy-8@2x.jpg 2x',
                },
                warehouse: {
                    src: 'https://media.sweetwater.com/m/header/welcome/photos/why-buy-9.jpg',
                    srcset: 'https://media.sweetwater.com/m/header/welcome/photos/why-buy-9.jpg, https://media.sweetwater.com/m/header/welcome/photos/why-buy-9@2x.jpg 2x',
                },
                dealzone: {
                    src: 'https://media.sweetwater.com/m/header/welcome/photos/why-buy-10.jpg',
                    srcset: 'https://media.sweetwater.com/m/header/welcome/photos/why-buy-10.jpg, https://media.sweetwater.com/m/header/welcome/photos/why-buy-10@2x.jpg 2x',
                },
            },
        };
    },
    props: {
        bannerType: {
            type: String,
            required: false,
            default: 'whyBuyList',
            validator: value => ['whyBuyList', 'whyBuyVideo'].indexOf(value) !== -1,
        },
        showFreeShippingMsg: {
            default: true,
            type: Boolean,
        },
    },
    methods: {
        addEvents() {
            // events.$on('popupShow', this.show);
        },
        open() {
            this.visible = true;
            this.canShowImages = true;
            this.youtubeSrc = 'https://www.youtube-nocookie.com/embed/uql9NPOk-4o';
            document.body.classList.add('no-scroll');
            this.setFocus('.newModal__btn--close');
            this.lockFocus();
            if (this.bannerType === 'whyBuyList') {

                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                    'event': 'promotionClick',
                    'ecommerce': {
                        'promoClick': {
                            'promotions': [{
                                'id': '10_Reasons',
                                'name': 'Evergreen_Brand_2018',
                                'creative': 'Banner',
                                'position': 'sitewide',
                            }]
                        }
                    }
                });

            } else {

                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                    'event': 'promotionClick',
                    'ecommerce': {
                        'promoClick': {
                            'promotions': [{
                                'id': 'Explainer_Video',
                                'name': 'Evergreen_Brand_2018',
                                'creative': 'Banner',
                                'position': 'sitewide',
                            }]
                        }
                    }
                });
            }
        },
        setFocus(focusClass) {
            setTimeout(function(){
                if (document.querySelector(focusClass)) {
                    document.querySelector(focusClass).focus(); 
                }
            }, 100);
        },
        lockFocus () {
            setTimeout(function(){
                const modal = document.querySelector('.modal__why-buy'),
                focusable = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'),
                firstFocusable = focusable[0],
                lastFocusable = focusable[focusable.length - 1];


                if(firstFocusable){
                    firstFocusable.focus();
                }

                firstFocusable.addEventListener('keydown', function(e){
                    if (e.shiftKey && e.key === 'Tab') {
                        e.preventDefault();
                        lastFocusable.focus();
                    }
                })

                lastFocusable.addEventListener('keydown', function(e){
                    if (e.key === 'Tab' && !e.shiftKey) {
                        e.preventDefault();
                        firstFocusable.focus();
                    }
                })
                
            }, 100);
        },
        close() {
            this.visible = false;
            this.youtubeSrc = '';
            document.body.classList.remove('no-scroll');
            this.setFocus('.why-buy-list')
        },
        closeComplete() {
            axios.post('/webservices_sw/customer/dismiss-banner', { banner: this.bannerType });
        },
        getImage(section, attr = 'src') {
            return this.canShowImages ? this.images[section][attr] : undefined;
        },
        show(args) {
            // this.visible = true;
        },
        itemClicked() {
            // Removed old ga tracking 7/30/2024
        },
    },
};
</script>

<style rel="stylesheet/scss" lang="scss" type="text/scss" scoped>
@import '~@sweetwater/sass-resources/sass';

.no-scroll {
    overflow: hidden;
}

.modal__mask {
    flex-direction: column;

    .modal__container {
        height: 100%;
        -webkit-overflow-scrolling: touch;

        @include media('<=large') {
            width: 90%;
        }
    }
}

.why-buy-video {
    background: #eee;
    height: 0;
    margin-top: 1em;
    max-width: 100%;
    overflow: hidden;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 56.25%;
    position: relative;

    iframe,
    object,
    embed {
        height: 100%;
        left: 0;
        overflow: hidden;
        -webkit-overflow-scrolling: touch;
        position: absolute;
        top: 0;
        width: 100%;
    }
}

.watch-now-btn {
    border: 1px solid;
    border-radius: 50px;
    display: inline-block;
    font-size: 14px;
    font-weight: 600;
    margin-left: 7px;
    padding: 3px 5px 3px 10px;

    span {
        vertical-align: middle;
    }

    svg {
        width: 20px;
    }

    &:hover {
        background: #1173a8;
        border-color: #1173a8;
        color: #fff;

        svg {
            /* fill: currentColor; */
        }
    }
}

.why-buy-video-text {
    color: #333;
    line-height: 1.5;
    max-width: 820px;
    padding: 2em 2em 0;
    text-align: left;

    @media all and (max-width: 600px) {
        padding: 1em 0;
    }

    .why-buy-btn {
        padding: 2em 0 1.5em;
        text-align: center;

        a {
            border: 2px solid #333;
            border-radius: 0;
            color: #333;
            font-weight: 600;
            padding: 1em 2em;
            text-transform: uppercase;

            &:hover {
                background: #333;
                color: #fff;
            }
        }
    }
}

.open-modal {
    color: #1173a8;
    cursor: pointer;
    position: relative;

    svg {
        fill: currentColor;
    }

    &::before,
    &::after {
        content: '';
        display: block;
        height: 100%;
        position: absolute;
        top: 0;
        width: 40px;
    }

    &::before {
        background-image:
            linear-gradient(
                to left,
                #f3f3f3 5%,
                rgba(243, 243, 243, 0) 100%
            );
        left: -40px;
    }

    &::after {
        background:
            linear-gradient(
                to right,
                #f3f3f3 5%,
                rgba(243, 243, 243, 0) 100%
            );
        right: -40px;
    }

    span.why-buy-video:focus {
        outline: none;
        padding: 6px 4px 8px 4px;
        box-shadow: 0px 0px 3px 2px #05629c !important;
    }

    span.why-buy-list:focus {
        outline: none;
        box-shadow: 0px 0px 3px 2px #fff !important;
    }
}

.why-buy-banner {
    background:
        #f3f3f3
        url('https://media.sweetwater.com/m/header/welcome/pattern-icons.png')
        repeat-x top center;
    background-size: 280px auto;

    /* color: #fff; */

    display: block;
    overflow: hidden;
    -webkit-overflow-scrolling: touch;
    position: relative;
    text-align: center;
    text-decoration: none;

    &.banner--list {
        background: #1173a8 url('https://media.sweetwater.com/m/header/images/background-welcome-banner.png') repeat-x scroll top center !important; /* stylelint-disable-line declaration-no-important */
        background-size: 515px auto !important; /* stylelint-disable-line declaration-no-important */
        color: #fff;

        .open-modal {
            background: none;
            color: #fff;

            &::before,
            &::after {
                display: none;
            }

            svg {
                fill: #fff;
            }
        }
    }

    &:hover {
        &::before {
            background-color: rgba(0, 0, 0, 0.07);
        }

        svg {
            /* transform: scale(1.2); */
        }
    }

    &::before {
        content: '';
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
    }

    .why-buy-banner__inner {
        margin: 0 auto;
        max-width: 1400px;
        position: relative;

        .border {
            background: #222;
            bottom: -32px;
            height: 4px;
            position: relative;
            width: 100%;
            z-index: 0;
        }

        h2 {
            background: #fff;
            display: inline-block;
            font-size: 2em;
            padding: 10px;
            position: relative;
            z-index: 1;

            @media all and (max-width: 480px) {
                font-size: 1.7em;
            }

            a[href^='tel'] {
                color: inherit;
                text-decoration: none;
            }

            svg {
                height: 35px;
                transform: scale(1);
                width: 40px;

                &:hover { /* stylelint-disable-line max-nesting-depth */
                    transform: scale(1);
                }
            }
        }

        svg {
            fill: currentColor;
            height: 20px;
            transition: transform 0.1s ease;
            vertical-align: middle;
            width: 20px;
        }

        p {
            /* color: #fff; */
            /* cursor: pointer; */
            background: #f3f3f3;
            display: inline-block;
            padding: 0.5em 1em;
        }
    }

    /* modal styling overrides */
    .modal__mask {
        @media all and (max-width: 1000px) {
            padding: 0;
        }
    }

    .modal__body {
        border-bottom: 5px solid #222;
        border-top: 5px solid #222;
        padding-bottom: 2em;
    }

    .modal__btn--close {
        background: #222;
        border: 5px solid #fff;
        right: -10px;
        top: -10px;

        &:hover {
            background: #000;
        }

        svg {
            fill: #fff;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 17px;

            @media all and (max-width: 480px) {
                width: 14px;
            }
        }
    }
}

.why-buy-grid {
    color: inherit;
    counter-reset: reasons;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    .why-buy-grid__item {
        box-sizing: border-box;
        color: #2e2d2b;
        padding: 1em;
        width: 50%;

        @media all and (max-width: 560px) {
            width: 100%;
        }

        img {
            width: 100%;
        }
    }

    .why-buy-grid__item__text { /* stylelint-disable-line selector-class-pattern */
        display: flex;

        a {
            font-weight: 700;
        }
    }

    .why-buy-grid__item__num { /* stylelint-disable-line selector-class-pattern */
        font-size: 3em;
        padding: 0 0.5em 0 0.3em;

        @media all and (max-width: 560px) {
            padding: 0 0.3em 0 0;
        }

        &::before {
            content: counter(reasons);
            counter-increment: reasons; /* Increment the value of section counter by 1 */
            display: block;
        }
    }

    .why-buy-grid__item__description { /* stylelint-disable-line selector-class-pattern */
        padding: 0.5em 0;
        text-align: left;
    }
}
</style>
